import { css } from "styled-components";

/*
  Modo compacto de las cards laterales del editor de campaña (< 1200px).
  Cada card pasa de "etiqueta arriba / valor abajo" a filas "etiqueta | valor",
  y las cards se acomodan en columnas tipo masonry para no dejar huecos.
  Se aplica dentro de .leftSideCards / .rightSideCards (ver leftSideStyle / rightSideStyle).
*/
const compactSidebarCards = css`
  @media only screen and (max-width: 1199px) {
    /* Contenedores que alternan etiqueta / valor -> grilla de 2 columnas */
    .cardGeneral .ant-col > div:not(.calendar-container):not(.infoDate):not(.brandClientNameContainer),
    .cardGeneral .ant-col-24,
    .calendar-container .contentDate {
      display: grid;
      grid-template-columns: auto minmax(90px, 1fr);
      align-items: center;
      column-gap: 10px;
      row-gap: 10px;
      text-align: left;
    }
    .cardGeneral,
    .cartBudget,
    .cartAudience {
      padding: 12px;
      line-height: 22px;
    }
    .cardGeneral .ant-row,
    .cardGeneral .ant-col {
      width: 100%;
    }
    .infoDate,
    .statusTitle,
    .infoTotalSpots,
    .titleInfo {
      margin: 0;
      text-align: left;
      font-size: 12px;
      line-height: 18px;
    }
    .brandClientNameContainer,
    .statusContainer,
    .totalSpotsContainer,
    .content-info {
      margin: 0;
      min-width: 0;
      padding: 4px 8px;
    }
    .brandClientName,
    .statusName,
    .totalSpots {
      font-size: 13px;
      line-height: 20px;
    }
    .calendar-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .contentDate .ant-calendar-picker {
      width: 100%;
    }

    /* Presupuesto (izq) y presupuesto ajustado (der): etiqueta, valor y botón en línea */
    .cartBudget {
      gap: 6px;
    }
    .cartBudget > .ant-row:first-child {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
    }
    .cartBudget > .ant-row:first-child > .ant-col {
      width: auto;
      flex: 1 1 auto;
      min-width: 0;
    }
    .cartBudget > .ant-row:first-child > .ant-col:first-child {
      flex: 0 0 auto;
    }
    .cartBudget .text-title {
      margin: 0;
    }
    .cartBudget .content-info {
      margin-top: 0 !important;
    }
    .cartBudget .groupFilterButton {
      height: 28px;
      padding: 0 10px;
      margin: 0;
    }

    /* CPM promedio: contadores + "Ver detalle" en una fila */
    .cartAudience .line-divider {
      margin: 6px 0 4px;
    }
    .cartAudience .col-card {
      width: auto;
      margin: 0 !important;
    }
    .cartAudience .col-card .ant-row-flex {
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 6px;
      font-size: 15px;
    }
    .cartAudience .seeDetailsBtn {
      width: auto;
      margin: 0;
      padding: 2px 10px;
    }
  }

  /* Tablet horizontal / laptop chica: 2 columnas masonry por sidebar */
  @media only screen and (min-width: 992px) and (max-width: 1199px) {
    display: block;
    column-count: 2;
    column-gap: 10px;

    > * {
      display: block;
      width: 100%;
      break-inside: avoid;
      -webkit-column-break-inside: avoid;
      margin-bottom: 12px;
    }
    > *:empty {
      display: none;
    }
  }
`;

export default compactSidebarCards;
